import { ComplianceSettings } from '@/components/compliance/ComplianceSettings';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Settings } from 'lucide-react';
import { useUser } from '@clerk/clerk-react';

export default function Documents() {
  const { user } = useUser();
  // The threshold is global; the server only accepts changes from admins.
  const isAdmin = user?.publicMetadata?.role === 'admin';

  return (
    <div className="container mx-auto p-4">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Documents</h1>
        
        {isAdmin && (
        <Dialog>
          <DialogTrigger asChild>
            <Button variant="outline" size="sm" className="flex items-center gap-2">
              <Settings className="h-4 w-4" />
              Compliance Settings
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-3xl">
            <DialogHeader>
              <DialogTitle>Compliance Settings</DialogTitle>
            </DialogHeader>
            <ComplianceSettings />
          </DialogContent>
        </Dialog>
        )}
      </div>
      
      {/* Rest of the Documents page content */}
    </div>
  );
} 